import { jsx as t } from "react/jsx-runtime";
import { useState as n } from "react";
import { components as c } from "react-select";
import { MultiValueLabelText as p } from "./styles.js";
import { isEllipsisActive as a } from "../../utils/isEllipsisActive/index.js";
import { Tooltip as u } from "../Tooltip/Tooltip.js";
const x = (e) => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    data: o,
    selectProps: { getOptionLabel: i }
  } = e, [r, s] = n(null), m = a(r), l = i(o);
  return /* @__PURE__ */ t(u, { tooltip: l, show: m, children: /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(c.MultiValueLabel, { ...e, children: /* @__PURE__ */ t(p, { ref: s, children: l }) }) }) });
};
export {
  x as MultiValueLabel
};
//# sourceMappingURL=MultiValueLabel.js.map
